// ======================================================================
// File Name       : ServiceSystemUsageListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Col, Button, Form } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import DialogConfirm from '../../components/DialogConfirm';
import * as MessageTemplate from '../../constants/MessageTemplate';
import * as ServiceRecordAction from '../../actions/serviceRecord/ServiceRecordAction';
import { VALIDATE_TYPE, RETURN_MAX_NUM } from '../../constants/index';
import RenderField from '../../utils/ReduxFormUtils';
import { getDownloadFormMonths } from '../../utils/ServiceRecordUtils';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';

class ServiceSystemUsageListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectTargetMonth: '',
      targetMonths: [],
      showExportModal: false,
      monthList: [],
    };
    this.openDLDialog = this.openDLDialog.bind(this,
                                              MessageTemplate.BULK_EXPORT,
                                              null);
    this.downloadFormOK = this.downloadFormOK.bind(this);
    this.openDownloadConfirmDialogCancel = this.openDownloadConfirmDialogCancel.bind(this);
    this.createParams = this.createParams.bind(this);
  }

  componentWillMount() {
    const list = getDownloadFormMonths();
    if (this.props.downloadFormMonthList.length) {
      const firstMonthStore = this.props.downloadFormMonthList[0];
      const firstMonthList = list[0];
      if (firstMonthList.value !== firstMonthStore.value) {
        this.props.dispatch(ServiceRecordAction.getDownloadFormMonthList(list));
      }
    } else {
      this.props.dispatch(ServiceRecordAction.getDownloadFormMonthList(list));
    }
  }

  openDLDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showExportModal: true });
  }

  openDownloadConfirmDialogCancel() {
    this.setState({ showExportModal: false });
  }

  downloadFormOK() {
    const paramDL = this.createParams();
    this.props.dispatch(ServiceRecordAction.downloadFormRecord(paramDL));
    this.setState({ showExportModal: false });
  }
  createParams() {
    let param = {};
    if (!this.props.selectTargetMonth) {
      param = { selectTargetMonth: this.props.downloadFormMonthList[0].name };
    } else {
      param = {
        ...this.props.selectTargetMonth,
      };
    }
    param.selectTargetMonth = param.selectTargetMonth && param.selectTargetMonth.replace('/', '');
    param.enterpriseId = this.props.authedUser.enterpriseId;
    return param;
  }

  render() {
    const { selectTargetMonth, downloadFormMonthList } = this.props;
    const { openDownloadConfirmDialog } = this.props;
    let defaultMonth = '';
    if (downloadFormMonthList && downloadFormMonthList[0] && downloadFormMonthList[0].name) {
      defaultMonth = downloadFormMonthList[0].name;
    }
    return (
      <div>
        <h3>ダウンロードする対象を指定してください</h3>
        <Form className='form-horizontal' style={{ display: 'flow-root' }}>
          <Form.Group className="margin-top-20">
            <Col sm={12}>
              <Col sm={3} className="form-label">
                年月指定
              </Col>
              <Col sm={7}>
                <RenderField
                  type="selectbox"
                  name="selectTargetMonth"
                  label="コンテンツ種別"
                  value={selectTargetMonth && selectTargetMonth !== '' ? selectTargetMonth : defaultMonth}
                  data={downloadFormMonthList}
                />
              </Col>
            </Col>
          </Form.Group>
          <Form.Group className="text-center ">
            <Col sm={12}>
              <Button variant="primary" className="btn-96 margin-top-20" onClick={this.openDLDialog}>
                          ダウンロード
              </Button>
            </Col>
          </Form.Group>
          <DialogConfirm
            showModal={this.state.showExportModal}
            onCancel={this.openDownloadConfirmDialogCancel}
            mdSize={this.mdSize}
            content={this.content}
            onOK={this.downloadFormOK}
          />
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { authedUser } = state.authed;
  const { downloadFormMonthList } = state.serviceRecord;
  const { serviceRecordDownloadForm } = state.form;
  let selectTargetMonth = '';
  if (serviceRecordDownloadForm && serviceRecordDownloadForm.values) {
    selectTargetMonth = serviceRecordDownloadForm.values;
  }
  return {
    ...{ serviceRecordDownloadForm },
    authedUser,
    selectTargetMonth,
    downloadFormMonthList,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'serviceRecordDownloadForm',
  enableReinitialize: true,
  touchOnChange: true,
})(ServiceSystemUsageListContainer));
